var map = {
	"./bio-based-waste-stream-biocomposite/data.pdf": [
		1137,
		1137
	],
	"./cellulose-acoustic-panel/data.pdf": [
		7376,
		7376
	],
	"./compostable-foam/data.pdf": [
		7998,
		7998
	],
	"./cork-based-material/data.pdf": [
		4750,
		4750
	],
	"./fish-scale-board/data.pdf": [
		9605,
		9605
	],
	"./mycelium-based-acoustic-panels/data.pdf": [
		344,
		344
	],
	"./natural-fibre-boards/data.pdf": [
		1055,
		1055
	],
	"./osl/data.pdf": [
		1287,
		1287
	],
	"./recyclable-carton-board/data.pdf": [
		1730,
		1730
	],
	"./recycled-glass-panels/data.pdf": [
		3467,
		3467
	],
	"./recycled-paper-boards/data.pdf": [
		2675,
		2675
	],
	"./recycled-paper-composite/data.pdf": [
		8927,
		8927
	],
	"./recycled-paper-panel/data.pdf": [
		6194,
		6194
	],
	"./recycled-pet-acoustic-solutions/data.pdf": [
		7793,
		7793
	],
	"./water-resistant-lignin-coating/data.pdf": [
		5468,
		5468
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8033;
module.exports = webpackAsyncContext;